const Wx = () => import('@/views/bind/wxBind')
const Wb = () => import('@/views/bind/wbBind')
const QQ = () => import('@/views/bind/qqBind')
const Bind = () => import('@/views/bind/index')
export default {
  path: '/bind',
  name: 'bind',
  component: Bind,
  children: [
    {
      path: '/bind/wx',
      component: Wx,
      name: 'wx_bind',
      meta: {
        title: '微信绑定'
      }
    }, {
      path: '/bind/wb',
      component: Wb,
      name: 'wb_bind',
      meta: {
        title: '微博绑定'
      }
    }, {
      path: '/bind/qq',
      component: QQ,
      name: 'qq_bind',
      meta: {
        title: 'QQ绑定'
      }
    }
  ]
}
